/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.20/esri/copyright.txt for details.
*/
const o=1,t=[0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1],i=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],n=256,e={outlineWidth:.7,outerHaloWidth:.7,innerHaloWidth:.7,outlinePosition:0};export{t as ALPHA_TO_RGBA_CHANNEL_SELECTOR_MATRIX,e as HIGHLIGHT_SIZING,i as RGBA_TO_RGBA_CHANNEL_SELECTOR_MATRIX,n as SHADE_TEXTURE_SIZE,o as SIGMA};
